import { responseCodes } from '@config';

export interface MutationResponse<T> {
  code: responseCodes;
  message: string;
  success: boolean;
  payload?: T;
}
